import {
    FETCH_SHIPMENT_ROTATION_NO,
    FAIL_FETCH_SHIPMENT_ROTATION_NO,
    SUCCESS_FETCH_SHIPMENT_ROTATION_NO,

    FETCH_SHIPMENT_DATA,
    FAIL_FETCH_SHIPMENT_DATA,
    SET_SHIPMENT_DATA,
    // SUCCESS_UPDATE_PRINT_FLAG,
    SET_SHIPMENT_STATE,
    RESET_SHIPMENT_STATE,

    UPDATE_SHIPMENT_FLAG,
    FAIL_UPDATE_SHIPMENT_FLAG,
    SUCCESS_UPDATE_SHIPMENT_FLAG,


    RESET_PROCESS_ERROR
} from '../actions';


import moment from 'moment';

const initials = {

    /*common*/
    isFetching: false,
    error: undefined,
    isProcessError : false,

    /*data*/
    data: [],
    /*tableState*/
    selections: [],
    filters : [],
    sorts : [{columnName:'TorikomiDateTime',direction:'asc'}],

    /*conditions*/
    deliveryDate : moment(),
    extractCarNumber : '',
    extractRotationNO : null,
    rotationNoDataIsError:false,
    rotationNoHasNull: false,

    /*input*/
    inputCarNumber:'',
    inputRotationNO:'',
    /*(hold)*/
    bufInputCarNumber : '',
    bufInputRotationNO : '',

    /*suggestion*/
    rotationNoData:[],

    /*details relations*/
    isDetailsUpdate : false,

    /*process*/
    isCompleteUpdate : false,
}

const initialState = Object.assign({},initials);
export default function ShipmentSettings(state = initialState, action) {
    let ret = Object.assign({}, state, {});
    switch (action.type) {
        case FETCH_SHIPMENT_ROTATION_NO:
            ret.isFetching = true;
            ret.rotationNoData = [];
            ret.rotationNoDataIsError = false;
            return ret;
        case FAIL_FETCH_SHIPMENT_ROTATION_NO:
            ret.isFetching = false;
            ret.error = action.payload.err;
            ret.isProcessError = true;
            return ret;
        case SUCCESS_FETCH_SHIPMENT_ROTATION_NO:
            const res = action.payload.data;
            ret.rotationNoData = res.map(e=>{
            return {label: e.RotationNO, value: e.RotationNO};
            }).filter(e=>(e));
            ret.isFetching = false;
            //ret.rotationNoHasNull = ret.rotationNoData.length !== res.length;
            ret.rotationNoDataIsError = Boolean(res.length === 0);
            return ret;
        case FETCH_SHIPMENT_DATA:
            ret.isFetching = true;

            ret.bufInputCarNumber = action.payload.carNumber;
            ret.bufInputRotationNO = !(action.payload.rotationNO) ? '' : action.payload.rotationNO;

            ["selections","filters","sorts"].forEach((key)=>{
                ret[key] = initials[key];
            });
            return ret;
        case FAIL_FETCH_SHIPMENT_DATA:
            ret.isFetching = false;
            ret.error = action.payload.err;
            ret.isProcessError = true;
            ret.data = [];
            return ret;
        case SET_SHIPMENT_DATA:
            ret.data = action.payload.data;
            if(action.payload.data.length > 0){
                ret.inputCarNumber = ret.bufInputCarNumber;
                ret.inputRotationNO = ret.bufInputRotationNO;
            }
            else{
                ret.inputCarNumber = '';
                ret.inputRotationNO = '';
            }
            ret.isFetching = false;
            return ret;
        case SET_SHIPMENT_STATE:
            return Object.assign({}, state, action.payload);
        case RESET_SHIPMENT_STATE:
            Object.keys(initials).forEach((key)=>{
                ret[key] = initials[key];
            })
            return ret;
        case UPDATE_SHIPMENT_FLAG:
            ret.isFetching = true;
            return ret;
        case FAIL_UPDATE_SHIPMENT_FLAG:
            ret.isFetching = false;
            ret.error = action.payload.err;
            ret.isProcessError = true;
            return ret;
        case SUCCESS_UPDATE_SHIPMENT_FLAG:
            ret.isCompleteUpdate = true;
            return ret;
        case RESET_PROCESS_ERROR:
            ret.error = undefined;
            ret.isProcessError = false;
            return ret;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/shipment.js